import React, { useRef } from "react";

import { Button } from "../../components/tailwind";
import { ProductId } from "../product";
import { ProductProofreadRequestModal } from "./ProductProofreadRequestModal";

type Props = {
  productId: ProductId;
};

export const ProductProofreadRequestButton: React.FC<Props> = ({
  productId,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  return (
    <>
      <Button
        onClick={(): void => dialogRef.current?.showModal()}
        data-testid="proofread-button"
      >
        Send to proofreading
      </Button>
      <ProductProofreadRequestModal
        dialogRef={dialogRef}
        productId={productId}
      />
    </>
  );
};
